import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import axios from "axios";
import Modal from 'react-modal';
 
axios.defaults.withCredentials = true;
 
// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );
Modal.setAppElement('#root');
const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
root.render(<App />);